import { Routes } from '@angular/router';
import { canAccessCoreBasicsGuard, customerRoleGuard } from '@zvoove-market/shared';
import { FaqDetailBreadcrumb } from './faq/detail/faq-detail.breadcrumb';

export const knowledgeRoutes: Routes = [
  {
    path: 'knowledge',
    canActivate: [canAccessCoreBasicsGuard()],
    loadComponent: () => import('./shell/knowledge-shell.page').then((c) => c.KnowledgeShellPage),
    data: {
      breadcrumb: () => $localize`:@@general.knowledge:Knowledge`,
    },
    children: [
      {
        path: '',
        redirectTo: 'faq',
        pathMatch: 'full',
      },
      {
        path: 'faq',
        data: {
          breadcrumb: () => $localize`:@@knowledge.faq:Fragen & Antworten`,
        },
        children: [
          {
            path: 'search',
            data: {
              breadcrumb: () => $localize`:@@general.search:Suche`,
            },
            children: [
              {
                path: '',
                loadComponent: () => import('./faq/search/faq-search.page').then((c) => c.FaqSearchPage),
              },
              {
                path: ':entryId',
                loadComponent: () => import('./faq/detail/faq-detail.page').then((c) => c.FaqDetailPage),
                data: {
                  breadcrumb: FaqDetailBreadcrumb,
                },
              },
            ],
          },
          {
            path: ':categoryId',
            data: {
              breadcrumb: () => $localize`:@@general.category:Kategorie`,
            },
            children: [
              {
                path: '',
                loadComponent: () => import('./faq/list/faq.page').then((c) => c.FaqListPage),
              },
              {
                path: ':entryId',
                loadComponent: () => import('./faq/detail/faq-detail.page').then((c) => c.FaqDetailPage),
                data: {
                  breadcrumb: FaqDetailBreadcrumb,
                },
              },
            ],
          },
          {
            path: '',
            loadComponent: () => import('./faq/list/faq.page').then((c) => c.FaqListPage),
          },
        ],
      },
      {
        path: 'contact',
        data: {
          breadcrumb: () => $localize`:@@general.contacts:Kontakte`,
        },
        loadComponent: () => import('./contact/contact.page').then((m) => m.ContactPage),
      },
      {
        path: 'tutorial-video',
        data: {
          breadcrumb: () => $localize`:@@knowledge.tutorialVideos:Tutorial Videos`,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./tutorial-video/no-products/tutorial-video-no-products.page').then((c) => c.TutorialVideoNoProductsPage),
          },
          {
            path: ':productShorthand',
            loadComponent: () => import('./tutorial-video/tutorial-video.page').then((c) => c.TutorialVideoPage),
          },
        ],
      },
      {
        path: 'service-catalog/:productShorthand',
        data: {
          breadcrumb: () => $localize`:@@knowledge.serviceCatalog:Dienstleistungskatalog`,
        },
        loadComponent: () => import('./service-catalog/service-catalog.page').then((m) => m.ServiceCatalogPage),
      },
      {
        path: 'seminars',
        data: {
          breadcrumb: () => $localize`:@@knowledge.seminarsOnlineCourses:Seminare und Onlinekurse`,
        },
        loadComponent: () => import('./seminars/seminars.page').then((m) => m.SeminarsPage),
      },
      {
        path: 'newsletter-signup',
        canActivate: [customerRoleGuard()],
        data: {
          breadcrumb: () => $localize`:@@general.newsletter:Newsletter`,
        },
        loadComponent: () => import('./newsletter-signup/newsletter-signup.page').then((m) => m.NewsletterSignupPage),
      },
    ],
  },
];
